import { Step } from '../../CharitableGiving.meta';
import { GivingStrategy } from '../../api/useCharitableGivingQuery';

export const STEP_ID: Step = 'review';

export type ReviewStep = Extract<
  Step,
  | 'donor'
  | 'kindOfProperty'
  | 'donationAmount'
  | 'donationYear'
  | 'dafDonationYear'
  | 'dafGrantYear'
  | 'dafGrantAmount'
  | 'charityName'
  | 'fundAccounts'
>;

export const REVIEW_FIELDS_DICT: Record<GivingStrategy, ReviewStep[]> = {
  [GivingStrategy.DonationToDAF]: [
    'kindOfProperty',
    'donationAmount',
    'dafDonationYear',
    'dafGrantYear',
    'dafGrantAmount',
    'fundAccounts',
  ],

  [GivingStrategy.OutrightGiftsToCharity]: [
    'kindOfProperty',
    'donationAmount',
    'donationYear',
    'charityName',
    'fundAccounts',
  ],

  [GivingStrategy.QualifiedCharitableDonations]: [
    'donor',
    'donationAmount',
    'donationYear',
    'charityName',
    'fundAccounts',
  ],
};
